import React , { useState } from 'react';
import { galleries } from '../utils/galleryImages';
import { alternatives } from '../utils/alternative';
import styles from './gallery.module.css';

const Gallery = ({ galleryName }) => {
    const images = galleries[galleryName] || [];
    const galleryAlt = alternatives[galleryName] || [];

    const [isOpen, setIsOpen] = useState(false);
    const[currentIdx, setCurrentIdx] = useState(0);

    const openPopup = (idx) => {
        setCurrentIdx(idx);
        setIsOpen(true);
    };

    const closePopup = () => setIsOpen(false);

    const nextImage = () => setCurrentIdx((prev) => (prev + 1) % images.length);
    const prevImage = () => setCurrentIdx((prev) => (prev - 1 + images.length) % images.length);

    const currentImage = images[currentIdx];
    const altText = galleryAlt[currentImage] || '';

    return (
        <div className={styles.galleryContainer}>
            <div className={styles.galleryGrid}>
                {images.map((filename, idx) => (
                    <div key={idx} className={styles.imageContainer}>
                        <img
                            src={`/images/${galleryName}/${filename}`}
                            alt={`${idx + 1} from ${galleryName}`}
                            className={styles.galleryImage}
                            onClick={()=> openPopup(idx)}
                        />
                        {galleryAlt[filename] && (
                            <div className={styles.overlay}>
                                <span className={styles.alt}>{galleryAlt[filename]}</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {isOpen && (
                <div className={styles.popupOverlay} onClick={closePopup}>
                    <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                        <button className={`${styles.navButton} ${styles.left}`} onClick={prevImage}>&larr;</button>
                        <img
                            src={`/images/${galleryName}/${currentImage}`}
                            alt={altText}
                            className={styles.popupImage}
                        />
                        <button className={`${styles.navButton} ${styles.right}`} onClick={nextImage}>&rarr;</button>
                        <p className={styles.altText}>{altText}</p>
                        <button className={styles.closeButton} onClick={closePopup}>X</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery;
